import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { FileType } from '../file-type';
import { GlobalBookingFile } from '../global-booking-file';
import { HttpService } from '../service/http.service';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-global-booking-files',
  templateUrl: './global-booking-files.component.html',
  styleUrls: ['./global-booking-files.component.css']
})
export class GlobalBookingFilesComponent implements OnInit {

  files: GlobalBookingFile[] = [];
  fileTypes: FileType[] = [];

  constructor(
    private httpService: HttpService,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    forkJoin({
      files: this.httpService.getGlobalBookingFiles(),
      fileTypes: this.httpService.getAllFileTypes()
    }).subscribe(({
      files, fileTypes
    }) => {
      console.log(files);
      this.files = files;
      this.fileTypes = fileTypes;
    });
  }

  uploadFile(files: File[], fileForm: any) {
    if (files.length == 0) {
      return;
    }
    let file = files[0];
    this.httpService.postGlobalBookingFile(file).subscribe(id => {
      this.files.push(new GlobalBookingFile(file.name, false, null, true, true, id, file.size));
      this.toastService.addSuccess("Success", "File uploaded");
      fileForm.clear();
    });
  }

  downloadFile(selectedFile: GlobalBookingFile) {
    let fileName = selectedFile.name;
    if (fileName) {
      this.httpService.getGlobalBookingFileById(selectedFile.id!).subscribe(res => {
        let binaryData = [];
        binaryData.push(res.body!);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
        downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
    }
  }

  deleteFile(file: GlobalBookingFile) {
    this.confirmationService.confirm({
      message: "Are you sure that you want to delete this file?",
      accept: () => {
        this.httpService.deleteGlobalBookingFileById(file.id!).subscribe(() => {
          this.toastService.addSuccess("Success", "File deleted");
          this.removeFile(file);
        }, error => this.toastService.addError("Error", error.message));
      }
    });
  }

  removeFile(file: GlobalBookingFile) {
    let index = this.files.indexOf(file);
    if (index != -1) {
      this.files.splice(index, 1);
    }
  }

  updateFileInformation(file: GlobalBookingFile) {
    this.httpService.updateGlobalBookingFile(file).subscribe(() => {
      this.toastService.addSuccess("Success", "File information updated");
    }, error => {
      this.toastService.addError("Error", error.message);
    });
  }

}
